import styled from 'styled-components';
export const RedirectingMessage = styled.div `
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  font-family: ${({ theme }) => theme.globals.bodyFontFamily};
  font-size: ${({ theme }) => theme.typography.size.medium};
`;
